<template>
  <!--
    目前 Vue 里移动组件的根节点 DOM 时会抛出错误提示。
    因此二次封装 Popup 组件，且使用 get-container 时，需要在 Popup 外层套一个 div 标签，就可以解决这个问题
      https://github.com/youzan/vant/issues/4760
   -->
  <div>
    <van-popup
      v-model="isShow"
      position="right"
      :close-on-click-overlay="false"
      :close-on-popstate="true"
      class="full-width full-height"
      :get-container="getContainer"
    >
      <!-- header 头部 -->
      <ld-navbar @click-left="toggle">
        <van-search
          :placeholder="placeholder"
          v-model.lazy="value"
          @clear="clear"
        />
      </ld-navbar>

      <!-- tab 标签       <div v-show="(cityType==0 || cityType==1)&&showTab">-->
      <div v-show="(cityType==0)&&showTab">
        <van-tabs
          v-model="indexTab"
          @change="changeTab"
          ref="tabs"
          line-height="2px"
          line-width="20px"
          swipeable
        >
          <van-tab
            :title="$t('A014','国内')"
            :name="0"
          />
          <!--  disabled -->
          <van-tab
            :title="$t('A015','国际')"
            :name="1"
            :disabled='round==1'
          />
        </van-tabs>
      </div>

      <!-- 国际 -->
      <div v-if="cityType==0 && indexTab==1 && round!=1">
        <van-tree-select
          height="712"
          :items="items"
          :main-active-index.sync="activeIndex"
        >
          <template slot="content">
            <div class="wrapper">
              <mescroll-vue
                ref="mescroll"
                :down="down"
              >
                <van-cell>
                  <div v-if="activeIndex==0">
                    <van-cell-group title="历史">
                      <van-row :gutter="6">
                        <van-col
                          class="hotCity"
                          v-for="(hst,index4) in histList"
                          @click="selected(hst,index4)"
                          :key="index4"
                          :span="12"
                        >
                          <div class="hotCity-item van-ellipsis">
                            <span>{{ hst.cityName }}</span>
                          </div>
                        </van-col>
                      </van-row>
                    </van-cell-group>
                    <van-cell-group title="热门">
                      <van-row :gutter="6">
                        <van-col
                          class="hotCity"
                          v-for="(hot,index5) in intAirport.HOT"
                          @click="selected(hot,index5)"
                          :key="index5"
                          :span="12"
                        >
                          <div class="hotCity-item van-ellipsis">
                            <span>{{ hot.cityName }}</span>
                          </div>
                        </van-col>
                      </van-row>
                    </van-cell-group>
                  </div>
                  <div v-else>
                    <div
                      v-for="(state,index6) in intAirportData(intAirport.ALL,activeIndex-1)"
                      :key="index6"
                    >
                      <van-cell-group
                        :title="state.nationName"
                      >
                        <van-row :gutter="6">
                          <van-col
                            class="hotCity"
                            v-for="(ct,index7) in state.cityHotCityBeans"
                            @click="selected(ct,index7)"
                            :key="index7"
                            :span="12"
                          >
                            <div class="hotCity-item van-ellipsis">
                              <span>{{ ct.cityName }}</span>
                            </div>
                          </van-col>
                        </van-row>
                      </van-cell-group>
                    </div>
                  </div>
                </van-cell>
              </mescroll-vue>
            </div>
          </template>
        </van-tree-select>
      </div>

      <!-- 国内 -->
      <div
        class="wrapper"
        v-else
      >
        <mescroll-vue
          ref="mescroll"
          :down="down"
        >
          <!-- 历史记录 -->
          <van-collapse v-model="activeName">
            <van-collapse-item
              :title="$t('Historical','历史记录')"
              v-show="histList&&histList.length>0"
              name="1"
            >
              <template v-slot:value>
                <span @click.stop="clearHistList">清空</span>
              </template>
              <van-row :gutter="6">
                <van-col
                  class="hotCity"
                  v-for="(hot,index1) in histList"
                  @click="selected(hot,index1)"
                  :key="index1"
                  :span="historySpan"
                >
                  <div class="hotCity-item van-ellipsis">
                    <span v-if="cityjczdName">{{ hot.cityName }}{{ hot.jcZdName }}</span>
                    <span v-else-if="jczdName">{{ hot.jcZdName || hot.zdmc }}</span>
                    <span v-else-if="cityName">{{ hot.cityName }}</span>
                  </div>
                </van-col>
              </van-row>
            </van-collapse-item>

            <!-- 热门 -->
            <van-collapse-item
              :title="$t(title)"
              name="2"
              v-show="hotList.length>0"
            >
              <van-row gutter="6">
                <van-col
                  class="hotCity"
                  v-for="(hot,index2) in hotList"
                  @click="selected(hot,index2)"
                  :key="index2"
                  :span="hotSpan"
                >
                  <div class="hotCity-item van-ellipsis">
                    <span v-if="cityjczdName">{{ hot.cityName }}{{ hot.jcZdName }}</span>
                    <span v-else-if="jczdName">{{ hot.jcZdName || hot.zdmc }}</span>
                    <span v-else-if="cityName">{{ hot.cityName }}</span>
                  </div>
                </van-col>
              </van-row>
            </van-collapse-item>
          </van-collapse>

          <!-- 列表 -->
          <div
            v-for="(airport1,key1) in city"
            :key="key1"
          >
            <van-index-anchor :index="key1">
              <van-collapse
                accordion
                v-model="active"
                @change="slide(key1)"
              >
                <van-collapse-item
                  :title="key1"
                  :name="key1"
                >
                  <!-- 下面二个template的区别是第一个的地区在右边，第二个的地区在左边 -->
                  <template
                    v-slot:default
                    v-if="cityLeft"
                  >
                    <van-cell
                      v-for="(info,index8) in airport1"
                      :key="index8"
                      :title="info.jcZdName||(info.areaName || info.cityName)"
                      :value="info.jcZdName?`${info.cityName||''}   ${info.provinceName||''}`:`${info.parentName||''}   ${info.provinceName||''}   ${info.nationName||''}`"
                      @click.stop="selected(info,index8)"
                    />
                  </template>

                  <template
                    v-slot:default
                    v-else
                  >
                    <van-cell
                      v-for="(info,index8) in airport1"
                      :key="index8"
                      :title="info.jcZdName?`${info.cityName||''}   ${info.provinceName||''}`:`${info.parentName||''}   ${info.provinceName||''}   ${info.nationName||''}`"
                      :value="info.jcZdName||(info.areaName || info.cityName)"
                      @click.stop="selected(info,index8)"
                    />
                  </template>
                </van-collapse-item>
              </van-collapse>
            </van-index-anchor>
          </div>
        </mescroll-vue>
      </div>

      <!-- 搜索 -->
      <van-popup
        v-model="showSearch"
        position="bottom"
        :overlay="false"
        :close-on-click-overlay="false"
        :close-on-popstate="true"
        :style="{top: top+'px', height: '100%'}"
        class="shadow"
        v-if="this.cityType == 2"
      >
        <div
          v-for="(info, index4) in traintrue"
          :key="index4"
        >
          <van-cell
            :border="false"
            @click.stop="selected(info[0],index4)"
          >
            <van-row
              type="flex"
              align="center"
              gutter="8"
            >
              <van-col span="4">
                <div
                  class="nameTag main-color"
                  :style="{width:info[0].geoName?50+'px':38+'px'}"
                >
                  <span>{{ info[0].geoName ? "行政区" : "城市" }}</span>
                </div>
              </van-col>
              <van-col
                span="8"
                class="gray"
              >
                <span v-html="fillKey(info[0].geoName || (info[0].areaName || info[0].cityName))"/>
              </van-col>
              <van-col
                span="11"
                class="text-right gray"
              >
                {{ info[0].provinceName }} {{ info[0].nationName }} <span
                  v-show="info[0].geoName"
                  v-html="fillKey( info[0].cityName)"
                />
              </van-col>
            </van-row>
          </van-cell>
          <template v-for="(air, index5) in info">
            <van-cell
              :border="false"
              :key="index5"
              @click.stop="selected(air, index5)"
              v-show="air.jcZdName"
            >
              <van-row>
                <van-col span="3"/>
                <van-col span="2">
                  <ld-icon class="iconfont iconxiaji"/>
                </van-col>
                <van-col
                  span="19"
                  class="van-ellipsis"
                >
                  <span v-html="fillKey(air.jcZdName)"/>
                  <span v-html="fillKey(air.jcZdCode|| air.threeCode)"/>
                </van-col>
              </van-row>
            </van-cell>
          </template>
        </div>

        <van-collapse
          v-model="activeNames"
          @change="add"
          :border="false"
          class="icon_1"
        >
          <van-collapse-item
            name="1"
          >
            <template
              #title
            >
              <div style="color:#ccc;">
                查看更多火车站
              </div>
            </template>
            <div
              class="icon_3"
            >
              <div class="hello">
                <div
                  v-for="(info,index) in trainfalse"
                  :key="index"
                >
                  <template v-for="(air, index5) in info">
                    <van-cell
                      :border="false"
                      :key="index5"
                      @click.stop="selected(air, index5)"
                      v-show="air.jcZdName"
                    >
                      <van-row>
                        <van-col span="3"/>
                        <van-col span="2">
                          <ld-icon class="iconfont iconxiaji"/>
                        </van-col>
                        <van-col
                          span="19"
                          class="van-ellipsis"
                        >
                          <span v-html="fillKey(air.jcZdName)"/>
                          <span v-html="fillKey(air.jcZdCode|| air.threeCode)"/>
                        </van-col>
                      </van-row>
                    </van-cell>
                    &nbsp;
                  </template>
                </div>
              </div>
            </div>
            <span @click="add">点击收起</span>
          </van-collapse-item>
        </van-collapse>
        <nomore v-show="searchList.length<1"/>
      </van-popup>
      <van-popup
        v-model="showSearch"
        position="bottom"
        :overlay="false"
        :close-on-click-overlay="false"
        :close-on-popstate="true"
        :style="{top: top+'px', height: '100%'}"
        class="shadow"
        v-else
      >
        <div
          v-for="(info, index4) in searchList"
          :key="index4"
        >
          <van-cell
            :border="false"
            @click.stop="selected(info[0],index4)"
          >
            <van-row
              type="flex"
              align="center"
              gutter="8"
            >
              <van-col span="4">
                <div
                  class="nameTag main-color"
                  :style="{width:info[0].geoName?50+'px':38+'px'}"
                >
                  <span>{{ info[0].geoName ? "行政区" : "城市" }}</span>
                </div>
              </van-col>
              <van-col
                span="8"
                class="gray"
              >
                <span v-html="fillKey(info[0].geoName || (info[0].areaName || info[0].cityName))"/>
              </van-col>
              <van-col
                span="11"
                class="text-right gray"
              >
                {{ info[0].provinceName }} {{ info[0].nationName }} <span
                  v-show="info[0].geoName"
                  v-html="fillKey( info[0].cityName)"
                />
              </van-col>
            </van-row>
          </van-cell>
          <template v-for="(air, index5) in info">
            <van-cell
              :border="false"
              :key="index5"
              @click.stop="selected(air, index5)"
              v-show="air.jcZdName"
            >
              <van-row>
                <van-col span="3"/>
                <van-col span="2">
                  <ld-icon class="iconfont iconxiaji"/>
                </van-col>
                <van-col
                  span="19"
                  class="van-ellipsis"
                >
                  <span v-html="fillKey(air.jcZdName)"/>
                  <span v-html="fillKey(air.jcZdCode|| air.threeCode)"/>
                </van-col>
              </van-row>
            </van-cell>
          </template>
        </div>
        <div v-if="searchList.length >=10" style="padding: 10px 16px;color:#999999;font-size:14px;">
          <div @click="allHotelShow" v-show="hotelAllShow ==true">
            查看更多
            <van-icon name="arrow-up"/>
          </div>
          <div @click.stop="allHotelShow" v-show="hotelAllShow == false">
            收起
            <van-icon name="arrow-down"/>
          </div>
        </div>
        <nomore v-show="searchList.length<1"/>
      </van-popup>

      <!--  -->
    </van-popup>
  </div>
</template>

<script>

import {
  Popup,
  Tab,
  Tabs,
  IndexBar,
  IndexAnchor,
  Cell,
  CellGroup,
  Collapse,
  CollapseItem,
  Search,
  TreeSelect
} from 'vant'
import ldNavbar from 'Common/ldNavbar'
import MescrollVue from 'mescroll.js/mescroll.vue'
import nomore from 'Common/ldNoMore'
import {localget, localset, localremove} from 'Utils/storage.js'

import {getStatusbarHeight} from 'CommonUtils/plus'
import {getSysParameter} from 'Utils/publicApi'
import pinyin from 'js-pinyin'

export default {
  name: 'LdCity',
  components: {
    [Popup.name]: Popup,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Search.name]: Search,
    [TreeSelect.name]: TreeSelect,
    MescrollVue,
    ldNavbar,
    nomore,
    pinyin,
  },
  data() {
    return {
      down: {use: false},
      activeName: ['1', '2', '3'],//默认展开 历史记录 热门城市
      active: [],
      city: [],
      hotList: [],//热门城市数据
      // intHotList:[],//国际热门城市数据
      value: '', // 关键字搜索
      searchList: [], // 搜索列表
      //index: '0',//0 国内 1 国际
      isShow: false,
      showSearch: false,//显示走索列表
      //indexList:['历史','热门','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
      fun: ['tk', 'ht', 'tr', 'nation', 'car'],//方法名称
      arr: ['_airportHistory', '_cityHistory', '_stationHistory', '_cityHistory', '_carCityHistory'],//历史记录缓存 0 机票 1 酒店 2火车票 3 国籍
      activeIndex: 0,
      intAirport: {},
      title: '热门城市',
      indexTab: 0,
      histList: [],//历史记录
      timer: '',
      top: 54,//搜索列表 距离顶部距离
      other: false,
      VlueList: [],
      traintrue: [],
      trainfalse: [],
      activeNames: ['0'],
      hotelScreen:[],
      hotelAllShow:true // 酒店城市搜索列表是否展示全部城市
    }
  },
  props: {
    placeholder: {
      type: String,
      default: '请输入城市/机场'
    },
    sysType: {
      type: Number,
      default: 1,//标识符 ||去程返程   传入什么返回什么
    },
    // 国际国内
    tabIndex: {
      type: [Number, String],
      default: 0 // 0 国内 1 国际
    },
    cityType: {
      type: Number,
      default: 0 // 0 机票 1 酒店 2火车票 3 国家 4 用车
    },
    cplx: {
      type: String,
      default: '10901'
    },
    showTab: {//是否显示 tab标签
      type: Boolean,
      default: true
    },
    isCar: {//用车
      type: Boolean,
      default: false
    },
    cityjczdName: {// 显示城市+机场或者站点名称
      type: Boolean,
      default: false
    },
    jczdName: {// 显示机场或者站点名称
      type: Boolean,
      default: false
    },
    cityName: {// 只显示城市名称
      type: Boolean,
      default: true
    },
    hotSpan: {//热门城市 列宽
      type: [String, Number],
      default: 6
    },
    historySpan: {//历史记录 列宽
      type: [String, Number],
      default: 6
    },
    /*
        *挂载节点
        *值为选择器 例如 .tkEdit  #app body
        * 主要解决弹出式头部底部 被当前页面头部底部覆盖的问题
        * 最好挂载到当前页面的根节点上 页面跳转后会相应的移除该控件
        * 没有上面问题 不需传入
        * */
    element: {
      type: String,
      default: ''
    },
    isHotel: {
      type: Boolean,
      default: false
    },
    cityLeft: {//默认左侧显示机场
      type: Boolean,
      default: true
    },
    round:{
      type: [String, Number],
      default:0
    }
  },
  computed: {
    items() {//国际热门机场
      if (this.intAirport.ALL) {
        let arr = [{
          text: '历史/热门'
        }]
        this.intAirport.ALL.forEach(item => {
          if (item.dqflName) {
            arr.push({text: item.dqflName})
          }
        })
        return arr
      }
      return []
    },
  },
  mounted() {
    this.top += getStatusbarHeight()
  },
  created() {
    const webAddr = window.location.host
    getSysParameter('11605056').then(res => {
      console.log('city getSysParameter res : ', res)
      console.log('city : ', res.value1.includes(webAddr))
      if (res.value1 && res.value1.includes(webAddr)) {
        console.log('get basic use other js')
        this.other = true
      }
    })
  },
  methods: {
    add() {
      this.activeNames = ['0']
    },
    getTitle() {
      if (this.cityType == 1 && this.index == 1) {
        return 'F616'//国际热门
      } else if (this.cityType == 0 || this.cityType == 1 && this.index == 0) {
        return 'F619'//国内热门
      } else if (this.cityType == 2) {
        return 'sites'//热门站点
      }
      return 'Hot'//热门城市
    },
    intAirportData(data, index) {//国际机场数据
      return data[index].nationBeans
    },
    changeTab() {//国内国际
      this.title = this.getTitle()
      this.city = {}
      this.hotList = []
      if (this.cityType == 0 && this.indexTab == 1) {
        this.histList = localget('_airportIntHistory') || []//获取国际机票历史记录
      } else {
        this.histList = localget(this.arr[this.cityType]) || []//获取历史记录
      }
      this[this.fun[this.cityType]]()
      this.$refs.tabs && this.$refs.tabs.resize()
    },
    slide(k) {
      if (this.city[k].length) {
        let arr = this.city
        this.city = ''
        this.city = arr
        return
      }
    },
    tk() { // 0机票
      if (this.indexTab == 0) {
        // 默认显示国内  0
        // 获取国内热门
        if (this.cityType == 0) {
          this.getHotList({cplx: '10901', international: 1})
        }
        this.getCityList('10901')
      } else {
        let _intAirport = localget('_intAirport') || {}
        if (_intAirport['ALL']) {
          this.intAirport = ''
          this.intAirport = _intAirport
        } else {
          this.$api['city/gjHotCityByDq']().then(res => {
            this.intAirport = res.data || {}
            localset('_intAirport', this.intAirport)
          }).catch(res => {
          })
        }
      }
    },
    ht() {// 1 酒店
      if (this.indexTab == 0) {
        this.getHotList({cplx: '10903', international: 1})
        this.getCityList('10903')
      } else {
        // 国际酒店
        this.getHotList({cplx: '10910', international: 0})
        this.getCityList('10910')
      }
    },
    tr() {// 2 火车票
      this.getCityList('10904')
      if (this.isCar) {
        // 获取热门车站
        this.$api['city/findHot']()
          .then(res => {
            let cache = res.data || {}
            this.hotList = cache.findHotBeanList || []
          })
      } else {
        // 获取热门车站
        this.getHotList({cplx: '10904', international: 1})
      }
    },
    nation() {//3 国籍  保留 不能使用
      let _nation = localget('_nation') || {}
      if (_nation['A']) {
        this.city = _nation
      } else {
        this.$api['common/getFindNationList']()
          .then(res => {
            if (res) {
              let cache = res.data || {}
              this.city = cache.list || []
              localset('_nation', this.city)
              console.log('1号city', cache.list)
            }
          })
      }
    },
    car() {// 4 用车
      this.getHotList({cplx: '10903', international: 1})
      this.getCityList('10906')
      this.getHotList({cplx: '10906', international: 1})
    },
    // 清除历史记录
    clearHistList() {
      this.histList = []
      if (this.cityType == 0 && this.indexTab == 1) {
        localremove('_airportIntHistory')//国际
      } else {
        localremove(this.arr[this.cityType])
      }
    },
    // 检索 按照站点名称 全拼 首字母 和 城市名称来搜索  0 机票 1 酒店 2火车站
    getResultData(val) {
      if (this.cityType == 0 && this.indexTab == 1) {//国际机票检索
        this.searchAjax(val, '10902')
      } else if (this.cityType == 1 && this.indexTab == 1) {
        this.searchAjax(val, '10910')
      } else {
        let arr = []
        let reg = new RegExp(val, 'gim')
        let reg1 = new RegExp('^' + val + '$', 'gim')
        for (let k in this.city) {
          // if (arr.length < 12) {
          let city = this.city[k] || []
          for (let i = 0; i < city.length; i++) {
            let bl = false

            let item = city[i]
            if (this.cityType == 2) {
              item.showCity = 'show'
              item.showArea = 'noshow'
            } else {
              if (item.cityName && item.areaName == null) {
                item.showCity = 'show'
                item.showArea = 'noshow'
              } else {
                if (item.areaName) {
                  item.showCity = 'noshow'
                  item.showArea = 'show'
                }
              }
            }

            for (let k in city[i]) {
              var cache = city[i][k] || ''
              if (cache && typeof (cache) == 'string') {
                if (cache.match(reg1)) {
                  arr.push(city[i])
                  bl = false
                  break
                } else if (cache.match(reg)) {
                  bl = true
                }
              }

            }
            if (bl) {
              arr.push(city[i])
            }
          }
          // }
        }


        this.searchData(arr, val)
        // let arr = []
        // let reg = new RegExp(val, 'i')
        // for (let k in this.city) {
        // 	if (arr.length < 12) {
        // 		arr = arr.concat(this.city[k].filter(item => {
        //       console.log("item item:{}",item)
        // 			let bl = false
        // 			for (let i in item) {
        // 				if (this.cityType == 2) {
        // 					if (item.jcZdName.toString().search(reg) != -1) {
        // 						item.showCity = 'show'
        // 						item.showArea = 'noshow'
        // 						bl = true
        // 						break
        // 					}
        // 				} else {
        // 					if (item.cityName && item.cityName.indexOf(val) != -1 && item.areaName == null) {
        // 						item.showCity = 'show'
        // 						item.showArea = 'noshow'
        // 						bl = true
        // 						break
        // 					} else {
        // 						if (item.areaName && item.areaName.indexOf(val) != -1) {
        // 							item.showCity = 'noshow'
        // 							item.showArea = 'show'
        // 							bl = true
        // 							break
        // 						}
        // 					}
        // 				}
        // 			}
        // 			return bl
        // 		}))
        // 	}
        // }
        // this.searchData(arr, val)
      }
    },
    // 检索 调接口
    searchAjax(val, cplx) {
      if (val) {
        this.$api['city/findByKeyword']({
          keyword: val,
          cplx: cplx
        }).then(res => {
          let cache = res.data || {}
          this.searchData(cache.list || [],'',cplx)
        })
      }
    },
    // 检索 处理接口检索后的数据
    async searchData(_data, val,cplx) {

      console.log('searchData._data : ', _data)
      if (this.cityType == 2) {
        this.VlueList = _data
      }
      // console.log('val val : ', val)
      let obj = {}
      if (_data.length == 0 && this.isHotel) {
        let {data = {}} = await this.$api['city/findLocationList']({geoName: val})
        _data = data.listBeans
      }
      _data.forEach(item => {
        if (item.showCity && item.showCity === 'show') {
          if (obj[item.cityName]) {
            obj[item.cityName].push(item)
          } else {
            obj[item.cityName] = [item]
          }
        }
        if (item.showArea && item.showArea === 'show') {
          if (obj[item.areaName]) {
            obj[item.areaName].push(item)
          } else {
            obj[item.areaName] = [item]
          }
        }
      })
      if (Object.keys(obj).length > 0) {
        //  酒店  将搜索的城市排在第一位
        if(this.cityType == 1){
          this.hotelScreen = Object.entries(obj)
          this.hotelScreen.forEach((item,index)=>{
            if(item[0] == val){
              this.hotelScreen.splice(index, 1)
              this.hotelScreen.unshift(item)
            }
          })
          this.searchList = this.hotelScreen.map(item=>item[1])
          this.searchList = this.searchList.slice(0,10)
        } else{
          this.searchList = obj
        }
      } else {
        this.searchList = []
      }
      // console.log("cplx",cplx,_data)
      // console.log("obj",obj)
      if(cplx=='10902'){
        let objck={}
        _data.forEach(item => {

          if (objck[item.cityName]) {
            objck[item.cityName].push(item)
          } else {
            objck[item.cityName] = [item]
          }


          if (objck[item.areaName]) {
            objck[item.areaName].push(item)
          } else {
            objck[item.areaName] = [item]
          }

        })

        this.searchList = objck
      }
      console.log('this.searchList : ', this.searchList)
      //处理火车票选择查询的数据
      if (this.cityType == 2) {
        this.searchList = this.sortBySelectSearch(this.searchList, val)
      }
      this.showSearch = true
    },
    sortBySelectSearch(searchList, key) {
      let reg = new RegExp(key, 'gim')
      for (let i in searchList) {
        let sortPro = 'jcZdName'
        let selectArrs = []
        let otherArrs = []
        searchList[i].forEach(item => {
          if (item[sortPro].match(reg)) {
            item.isMatch = 1
            selectArrs.push(item)
          }
        })
        otherArrs = searchList[i].filter(item => !item.isMatch)
        selectArrs.sort((a, b) => a.jcZdName.localeCompare(b.jcZdName))
        this.traintrue = [selectArrs]
        this.trainfalse = [otherArrs]
        console.log('111', this.traintrue)
        console.log('111', this.trainfalse)
        // //查询匹配的数据根据站点名进行排序
        //
        // let resultArrs = selectArrs.concat(otherArrs)
        // searchList[i] = resultArrs

      }
      return searchList
    },
    sortBy(field) {
      //根据传过来的字段进行排序
      return (x, y) => {
        return y[field] - x[field]
      }
    },
    // 选中
    selected(info, index) {
      if (!info.hasOwnProperty('international')) {
        info.international = (this.indexTab == 0) ? 1 : 0
      }
      // 对用车选中城市时进行处理，将三字码改成机场三字码
      let pinyin = require('js-pinyin')
      if(this.isCar == true){
        for(let item1 in this.city){
          if(pinyin.getCamelChars(info.cityName).charAt(0) == item1){
            for( let item2 in this.city[item1]){
              if(info.jcZdName == this.city[item1][item2].jcZdName){
                info.jcZdCode = this.city[item1][item2].jcZdCode
              }
            }
          }
        }
      }
      this.$emit('selected', info, this.sysType, index)
      let citySelectLog = this.histList || []//localget(this.arr[this.cityType])||[]//历史记录
      if (citySelectLog.some(item => item.cityName == info.cityName) == false) {
        if (citySelectLog.length > 8) {//记录超出删除
          citySelectLog.pop()
        }
        citySelectLog.unshift(info)
        if (this.cityType == 0 && this.indexTab == 1) {
          localset('_airportIntHistory', citySelectLog)
        } else {
          localset(this.arr[this.cityType], citySelectLog)
        }
      }
      if (index == '北京') {
        if (info.cityPyjsm == 'bj') {
          info.threeCode = 'BJS'
        }
      } else if (index == '成都') {
        if (info.cityPyjsm == 'cd') {
          info.threeCode = 'CTU'
        }
      } else if (index == '西安') {
        if (info.cityPyjsm == 'xa') {
          info.threeCode = 'SIA'
        }
      }

      localset('_airportIntHistory', citySelectLog)
      this.showSearch = false
      this.clear()
      this.toggle()
    },
    // 热门城市
    getHotList(param) {
      let urlType = '0'
      if (this.other) {
        urlType = '1'
      }
      // 使用后端接口管控 原先方式弃用 2023年6月14日 15:14:17
      /*if (webAddr === 'app.zhy.tmc.tianxiapiao.cn') {
        urlType = '1'
      }*/
      param.urlType = urlType
      console.log('getHotList.param : ', param)
      this.$api['city/listGroupByTag'](param)
        .then(res => {
          if (res) {
            var cache = res.data || []
            this.hotList = cache[0] ? cache[0].cityBeanList : []
          }
        })
    },
    // 城市列表
    getCityList(cplx) {
      let local = this.$i18n.locale()// 'zh-CN' 'en-US'
      console.log('getCityList.local.be : ', local)
      if (this.other && cplx === '10903') {
        local = 'other_zh-CN'
      }
      // 使用后端接口管控 原先方式弃用 2023年6月14日 15:14:17
      /*if ((webUrl == 'app.zhy.tmc.tianxiapiao.cn' || webUrl == 'app.tmc.tianxiafen.com') && cplx === '10903') {
        local = 'other_zh-CN'
      }*/
      console.log('getCityList.local.af : ', local)

      let obj = {
        '10901': 'geo_10901_' + local,
        '10903': 'geo_10903_' + local,
        '10904': 'geo_10904_' + local,
        '10910': 'geo_10910_' + local,
        '10906': 'geo_10906_' + local,
      }
      let url = obj[cplx]
      let cache = ''
      try {
        //cache = localget(url)
        console.log('getCityList.cache : ', cache)
      } catch (e) {
        console.error(e.message)
      }
      if (cache) {
        this.city = cache
      } else {
        this.$api['city/' + url]()
          .then(res => {
            if (res) {
              var cache = res.data || {}
              this.city = cache
              try {
                localset(url, this.city)
              } catch (e) {
                console.error(e.message)
              }
            }
          })
      }
    },
    // 替换 关键词
    fillKey(name) {
      let reg = new RegExp(this.value, 'ig')
      if (name) {
        return name.replace(reg, '<font class="main-color">' + this.value.toUpperCase() + '</font>')
      }
      return name
    },
    clear() {
      this.value = ''
      this.searchList = []
      console.log('000')
    },
    toggle(obj) {
      this.isShow = !this.isShow
      if (this.isShow) {
        if (obj) {
          Object.assign(this, obj)
        }
        this.init()
        this.changeTab()
      }
      this.hotelAllShow = true
    },
    init() {
      // this.indexTab = this.tabIndex
      if(this.round==1){
        this.indexTab=0
      }
      this.clear()
    },
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer() {
      if (this.element) {
        return document.querySelector(this.element)
      }
      return ''
    },
    // 控制酒店搜索城市列表是否展示全部搜索结果
    allHotelShow () {
      this.hotelAllShow = !this.hotelAllShow
    }
  },
  watch: {
    cityType(val) {//类型
      var self = this
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        self.changeTab()
        clearTimeout(this.timer)
      }, 500)
    },
    tabIndex(val) {
      this.indexTab = val
      this.changeTab()
    },
    value(val) {//检索
      console.log("监听录入")
      if (val) {
        if (this.timer) {
          clearTimeout(this.timer)
        }
        var self = this
        this.timer = setTimeout(() => {
          self.getResultData(val)
          clearTimeout(this.timer)
        }, 500)
      } else {
        this.showSearch = false
        clearTimeout(this.timer)
        this.init()
      }
    },
    hotelAllShow(val){
      if(val == true && this.cityType == 1){
        this.searchList = this.searchList.slice(0,10)
      } else if(val == false && this.cityType == 1){
        this.searchList = this.hotelScreen.map(item=>item[1])
      }
    }
  },
}
</script>
<style lang="less" scoped>
.hotCity {
  margin-bottom: 10px;

  .hotCity-item {
    font-size: @font-size-12;
    color: @color-text-black;
    text-align: center;
    height: 34px;
    line-height: 34px;
    border-radius: 4px;
    border: solid 1px @color-background-lightGray;
  }
}

.wrapper {
  height: calc(100vh - 100px);
  overflow: hidden;
}

.nameTag {
  width: 38px;
  height: 16px;
  line-height: 16px;
  font-size: @font-size-10;
  border: 1px solid;
  padding: 0 6px;
  border-radius: 10px;
}

.icon_1 {
  padding: 0 24px 0 57px;
  margin: 0px 161px 0 0;
}

.icon_3 {
  width: 302px;
  margin: 0px 0 0 -52px;
}

</style>
